{
    "common": {
        "action": "Aktion",
        "back": "Zurück",
        "clockOut": "den Arbeitsschluss stempeln",
        "from": "Von",
        "logout": "Abmelden",
        "next": "Nächste",
        "skip": "Überspringen",
        "submit": "Bestätigen",
        "until": "Bis",
        "wholeDay": "Den ganzen Tag"
    },
    "containers": {
        "cacheBuster": {
            "updateAvailable": "Ein Update ist verfügbar!",
            "reload": "Neu laden"
        },
        "clockOutScreen": {
            "title": "Bereit, den Arbeitstag zu beenden, :firstName:?",
            "titleNoName": "Bereit, den Arbeitstag zu beenden?"
        },
        "commentScreen": {
            "startedWithoutShiftTitle": "Geben Sie den Grund an, warum Sie ohne Dienst begonnen haben.",
            "trackDivergenceTitle": "So wie es scheint, weichen Ihre Zeiten vom Zeitplan ab. Was ist der Grund dafür? "
        },
        "happinessScreen": {
            "title": "Wie haben Sie Ihren Arbeitstag erlebt?"
        },
        "inactiveScreen": {
            "title": "Leider haben Sie keinen Zugang zum ValkTimer.",
            "intro": "Ihr Konto wurde deaktiviert, d.h. Sie können nicht mehr auf die Funktionen des ValkTimers zugreifen.",
            "contact": "Ist dies nicht korrekt oder haben Sie Fragen? Wenden Sie sich an Ihren Vorgesetzten oder die Personalabteilung "
        },
        "goodbyeScreen": {
            "title": "Schönen Tag noch und bis bald!"
        },
        "loginScreen": {
            "enterPincode": "Geben Sie Ihre PIN ein",
            "userNotFound": "Leider ist diese Kombination falsch. Bitte geben Sie Ihren Mitarbeitercode erneut ein. ",
            "title": "Willkommen, geben Sie Ihren Mitarbeitercode ein."
        },
        "masterLoginScreen": {
            "title": "Willkommen, bitte geben Sie den Mastercode für den Zugang zum ValkTimer ein.",
            "wrongMasterCode": "Leider ist diese Kombination falsch. Bitte geben Sie den Mastercode erneut ein. "
        },
        "mealScreen": {
            "title": "Welche Mahlzeit haben Sie genommen?"
        },
        "pauseScreen": {
            "title": "Wie viele Minuten Pause hatten Sie?"
        },
        "selectShiftScreen": {
            "pleasantWorkDay": "Schöner Arbeitstag, :firstName:!",
            "unplannedShift": "Außerplanmäßiger Dienst",
            "whichShiftDoYouWantToStart": "Welchen Dienst möchten Sie starten, :firstName:?"
        }
    },
    "errors": {
        "unknownError": "Es ist ein unbekannter Fehler aufgetreten, bitte versuchen Sie es später noch einmal."
    },
    "types": {
        "mealType": {
            "hot": "Warm",
            "bread": "Brot",
            "none": "Kein"
        }
    }
}
